








































































































































































































































































































































import {
PropType,
computed,
defineComponent,
onBeforeUnmount,
onMounted,
ref,
watch,
} from "@nuxtjs/composition-api";
import { SfButton, SfCheckbox } from "@storefront-ui/vue";
import axios from "axios";
import DOMPurify from "dompurify";
import { ValidationObserver } from "vee-validate";
import CloudFlareCaptcha from "~/components/JetUi/atoms/Captcha/CloudFlareCaptcha.vue";
import JetInput from "~/components/JetUi/atoms/Input/JetInput.vue";
import JetUiButton from "~/components/JetUi/atoms/JetUiButton/JetUiButton.vue";
import Tooltip from "~/components/JetUi/atoms/Tooltip/Tooltip.vue";
import Warning from "~/components/JetUi/atoms/Warning/Warning.vue";
import SfSelect from "~/components/JetUi/molecules/SfSelect/SfSelect.vue";
import { useValidator } from "~/composables";
import {
JetFormName,
JetRegisterFormFields,
} from "../../LoginModal/forms/types";
import cnaeIdentifier from "../utils/cnaeIdentifier";

export default defineComponent({
  components: {
    ValidationObserver,
    JetUiButton,
    SfCheckbox,
    JetInput,
    SfButton,
    CloudFlareCaptcha,
    Warning,
    SfSelect,
    Tooltip,
  },
  props: {
    form: {
      type: Object as PropType<JetRegisterFormFields>,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showRecaptcha: {
      type: Boolean,
      default: false,
    },
    checkout: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const modelCheck = ref(false);
    const modelAgree = ref(false);
    const formDisabled = ref(true);
    const formCopy = ref<JetRegisterFormFields>();
    const emailError = ref<string | null>(null);
    const buttonText = ref("Register");
    const { validateCNPJ, validateCPF } = useValidator();
    const windowWidth = ref(0);

    watch(
      () => props.form,
      (newForm) => {
        formCopy.value = { ...newForm };
      },
      { immediate: true, deep: true }
    );

    watch(modelCheck, () => {
      formCopy.value = {
        rg_ie: "",
        isento: false,
        cnpj: "",
        password: "",
        confirmPassword: "",
        email: "",
        celular: "",
        date_of_birth: "",
        taxvat: "",
        gender: 4,
        firstName: "",
        segmento: "",
        vendedora: "",
        lastName: "",
        is_subscribed: false,
      };
    });

    const validateFields = (
      requiredFields: string[],
      form: JetRegisterFormFields
    ) =>
      requiredFields.some((field) => !form[field]) ||
      form.password !== form.confirmPassword;

    const pessoaFisicaValidatedForm = computed(() => {
      const requiredFields = [
        "firstName",
        "lastName",
        "date_of_birth",
        "taxvat",
        "password",
        "celular",
        "email",
      ];
      if (formCopy.value.gender == 4) {
        return true;
      }

      return (
        validateFields(requiredFields, formCopy.value) ||
        !validateCPF(formCopy.value.taxvat)
      );
    });

    const pessoaJuridicaValidatedForm = computed(() => {
      const requiredFields = [
        "firstName",
        "taxvat",
        "email",
        "celular",
        "password",
        "segmento",
      ];

      return (
        validateFields(requiredFields, formCopy.value) ||
        !validateCNPJ(formCopy.value.taxvat) ||
        (!formCopy.value.isento && !formCopy.value.rg_ie)
      );
    });

    const changeForm = (formToNavigateTo: JetFormName) => {
      emit("change-form", formToNavigateTo);
    };

    const setTradeName = async () => {
      formCopy.value.firstName = "";
      formCopy.value.lastName = "";
      if (validateCNPJ(formCopy.value.taxvat)) {
        const cnpj = formCopy.value.taxvat.replace(/\D/g, "");
        await axios
          .get(
            `https://cloud.jetsoft.com.br/JetServicos/apiservicos/apijetservico/wsobterdadosparceiro?inDocumento=${cnpj}`
          )
          .then((response) => {
            const name = response.data.SDT_ReceitaWS.nome as string;
            const segmento = cnaeIdentifier(
              response.data.SDT_ReceitaWS.atividade_principal[0].code
            );
            formCopy.value.segmento = segmento;
            formCopy.value.firstName = name;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };

    const submitForm = async () => {
      if (buttonText.value === "Register") {
        buttonText.value = "Cadastrando...";
      }
      if (formCopy.value.password !== formCopy.value.confirmPassword) {
        alert("Senhas não coincidem");
        return;
      }
      if (!modelCheck.value) {
        formCopy.value.gender = null;

        const listNames = formCopy.value.firstName.split(" ");
        formCopy.value.firstName = listNames.slice(0, -1).join(" ");
        formCopy.value.lastName = listNames[listNames.length - 1];
      }

      emit("submit", formCopy.value);
    };

    const isPasswordValid = (password: string): boolean => {
      let conditionsMet = 0;

      if (/[A-Z]/.test(password)) conditionsMet++;
      if (/[a-z]/.test(password)) conditionsMet++;
      if (/[^\dA-Za-z]/.test(password)) conditionsMet++;
      if (/\d/.test(password)) conditionsMet++;

      return (
        (conditionsMet >= 3 && password.length >= 8) || password.length === 0
      );
    };

    const setButtonDisabled = (result: boolean) => {
      formDisabled.value = result;
    };

    onMounted(() => {
      handleResize();
      window.addEventListener("resize", handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    watch(formCopy, (newForm) => {
      formCopy.value.firstName = DOMPurify.sanitize(newForm.firstName);
      formCopy.value.lastName = DOMPurify.sanitize(newForm.lastName);
      formCopy.value.email = DOMPurify.sanitize(newForm.email);
      formCopy.value.celular = DOMPurify.sanitize(newForm.celular);
    });

    return {
      modelCheck,
      modelAgree,
      formCopy,
      emailError,
      submitForm,
      changeForm,
      formDisabled,
      setButtonDisabled,
      validateCPF,
      validateCNPJ,
      pessoaFisicaValidatedForm,
      pessoaJuridicaValidatedForm,
      setTradeName,
      isPasswordValid,
      buttonText,
      windowWidth,
    };
  },
});
